import * as e from "react";
import { forwardRef as i } from "react";
const c = i(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#prefix__clip0_8218_970)" }, /* @__PURE__ */ e.createElement("rect", { fill: "#444", height: 18, rx: 9, width: 18 }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 6L12 12M12 6L6 12",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeWidth: 1.5
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "prefix__clip0_8218_970" }, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 18, width: 18 })))
  );
});
export {
  c as MarketStatusVoid
};
